/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 新增或修改老师/学生认证信息接口
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  collegeStudentCertification: order.CollegeStudentCertificationBaseInfoRes,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "patch",
    url: `/order/college-student-certification/base-info`,
    data: collegeStudentCertification,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
